import { useDataFormat } from 'Simple/Data.js'

export default function useDataTransform(props, value) {
  return useDataFormat({
    viewPath: props.viewPath,
    context: 'providers',
    format: p =>
      p.filter(x => x.connection_providers?.length > 0).map(x => x._id),
  })
}
